import merge from 'ramda/src/merge'

export default {
  data: () => ({
    pagination: {
      currentPage: 1,
      listMaxSize: parseInt(process.env.VUE_APP_LIST_MAX_SIZE),
      totalItems: null
    }
  }),

  methods: {
    pagination_createParams() {
      this.pagination.currentPage = this.$route.query.page ? parseInt(this.$route.query.page) : this.pagination.currentPage
      const listMaxSize = this.pagination.listMaxSize
      const offset = (this.pagination.currentPage - 1) * listMaxSize

      return {
        offset,
        max: listMaxSize
      }
    },

    pagination_setCurrentPage(newPage) {
      this.pagination.currentPage = newPage
    },

    pagination_getCurrentPage() {
      return this.pagination.currentPage
    },

    pagination_setTotalItems(count) {
      this.pagination.totalItems = count
    },

    pagination_getTotalItems() {
      return this.pagination.totalItems
    },

    pagination_pageChanged(query, getItemsCallback) {
      return page => {
        this.pagination.currentPage = page
        const newQuery = merge(query, {page: page})
        this.$router.push({query: newQuery})
        return getItemsCallback()
      }
    },

    pagination_updatePage(getItemsCallback, items) {
      // adjust pagination overflow - might happen when deleting
      if (items.length > 0 || this.pagination.currentPage <= 1) return false

      this.pagination_pageChanged(getItemsCallback)(this.pagination.currentPage - 1)
    }
  }
}
